{
  "$id": "wealthlane://forms/company-mapping",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../company-mapping.domain.json",
  "properties": {
    "sourceCompanyId": {
      "$ref": "module://company-mapping#properties/sourceCompanyId",
      "required": true
    },
    "destinationCompanyId": {
      "$ref": "module://company-mapping#properties/destinationCompanyId",
      "required": true
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_COMPANY_MAPPING",
      "refreshEntities": ["CompanyMapping"],
      "invalidateQueries": ["getAllAllowedCompanyMappings"]
    }
  },
  "modes": {
    "create": {
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_COMPANY_MAPPING_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_COMPANY_MAPPING_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
